import { Component, OnInit } from "@angular/core";
import { IAppointment } from "src/app/shared/interfaces/appointment";
import { EAppointmentStatus } from "src/app/shared/interfaces/appointmentStatus-enum";
import { EPaymentStatus } from "src/app/shared/interfaces/paymentStatus-ennum";
import { EVisitType } from "src/app/shared/interfaces/visitType-enum";
import { ShamsiDatePipe } from "src/app/shared/pipes/shamsiDatePipe";
import { ApiService } from "src/app/shared/services/api.service";
import { DateService } from "src/app/shared/services/date.service";

@Component({
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html",
})
export class DashboardComponent implements OnInit {

  dashboardData: any;
  appointmentsList: IAppointment[];
  visitType = EVisitType;
  appointmentStatus: EAppointmentStatus;
  paymentStatus= EPaymentStatus;
  visitStatus = EAppointmentStatus;
  searchBody = {
      // id: 0,
      title: '',
      pageIndex: 1,
      pageSize: 10,
      type: null,
      status: null,
      paymentStatus: null
  }
  todayDate: any;
  
  constructor(private apiService: ApiService,
    private dateService: DateService,
    private dateShamsi: ShamsiDatePipe) {}

  ngOnInit() {
    this.getDashboardData();
    this.todayDate = this.dateService.getTodayPersianDate();
  }

  getDashboardData() {
    this.apiService.apiCall('post', '/api/Doctor/DoctorDashboard', {}).subscribe((res: any) => {
      console.log(res);
      this.dashboardData = res.body.model;
    })
  }

  getAppointmentList(page) {
    // this.fakeData.getAppointments().subscribe((res: IAppointment[]) => {
    //   this.appointmentsList = res;
    // })

    this.searchBody = {
      // id: 0,
      title: this.searchBody.title,
      pageIndex: page,
      pageSize: 10,
      type: Number(this.searchBody.type),
      status: Number(this.searchBody.status),
      paymentStatus: Number(this.searchBody.paymentStatus)
    }
    this.apiService.apiCall('post', '/api/Doctor/GetAllVisit', this.searchBody).subscribe((res: any) => {
      console.log(res);

      this.appointmentsList = res.body.model;
    })

  }

  convertUTCMinutesToLocal(utcMinutes: number): number | any {
    // Get the current date (ignoring time) in UTC
    const utcDate = new Date();
    utcDate.setUTCHours(0, 0, 0, 0); // Reset to 00:00 UTC
  
    // Add UTC minutes to the date
    utcDate.setUTCMinutes(utcMinutes);
  
    // Convert to local time
    const localHours = utcDate.getHours(); // Local hours
    const localMinutes = utcDate.getMinutes(); // Local minutes
  
    // Convert local time to total minutes from 00:00 local time
    return this.calculateTime(localHours * 60 + localMinutes);
  }

  // This function checks if the visit time passed, the buttons will become disabled 
  isActiveVisitLink(date, startVisit): boolean {

    // const now = new Date();
    // const currentMinutes = now.getHours() * 60 + now.getMinutes();

    // if(this.todayDate.slice(0,10) > date.slice(0,10) && currentMinutes > startVisit) {      
    //   return true;
    // }

    const now = new Date();
    const currentMinutes = now.getHours() * 60 + now.getMinutes();

    // Convert UTC startVisit to local minutes
    const utcDate = new Date(date);
    utcDate.setUTCHours(0, 0, 0, 0); // Reset to 00:00 UTC
    utcDate.setUTCMinutes(startVisit);

    // Get local time from UTC date
    const localHours = utcDate.getHours();
    const localMinutes = utcDate.getMinutes();
    const startVisitLocal = localHours * 60 + localMinutes;

    // Check if the visit time has passed
    if (this.todayDate.slice(0, 10) > date.slice(0, 10) || currentMinutes > startVisitLocal) {
        return true;
    }

    return false;
    
  }

  calculateTime(time) {
    const hours = Math.floor(time / 60);
    const minutes = time % 60;
    // Format the time as HH:mm
    const timeString = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
    return timeString
  }
}
